
export const listInnerEntityNameHelper = (item, formatMessage) =>{
    let name = item.name
    return name
}
